// extracted by mini-css-extract-plugin
export default {"container":"Lea-z","creativeContainer":"Mea-z","copy":"Nea-z","cta":"Oea-z","disabled":"Pea-z","flipped":"Qea-z","productCard":"Rea-z"};